import React, { useEffect, useState } from 'react';
import { useAuth } from 'contexts/AuthContext';
import {
  loadEnvSettings,
  loadEnvSettingsAsync,
  ENV_SETTINGS_CHANGED_EVENT,
} from 'system/envSettingsStore';
import {
  normalizeWorkspaceTabSettings,
  TAB_DISPLAY_MODE,
} from 'system/workspaceTabSettings';
import TabArea from './TabArea';
import CompactTabArea from './CompactTabArea';

function readDisplayMode(compCd) {
  return normalizeWorkspaceTabSettings(loadEnvSettings(compCd).tabs).displayMode;
}

/** 환경설정 displayMode에 따라 라벨형 / 컴팩트 호버형 탭 바를 고른다 */
export default function WorkspaceTabBar() {
  const { compCd } = useAuth();
  const [displayMode, setDisplayMode] = useState(() => readDisplayMode(compCd));

  useEffect(() => {
    let cancelled = false;
    const sync = () => {
      if (!cancelled) setDisplayMode(readDisplayMode(compCd));
    };
    sync();
    loadEnvSettingsAsync(compCd).then(sync).catch(sync);
    window.addEventListener(ENV_SETTINGS_CHANGED_EVENT, sync);
    return () => {
      cancelled = true;
      window.removeEventListener(ENV_SETTINGS_CHANGED_EVENT, sync);
    };
  }, [compCd]);

  if (displayMode === TAB_DISPLAY_MODE.COMPACT) {
    return <CompactTabArea />;
  }
  return <TabArea />;
}
